import React from 'react';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { IconButton } from 'src/components/atoms/IconButton';

export type Campaign = {
  id: string;
  name: string;
};

type CampaignListProps = {
  campaigns: Campaign[];
  onRemove?: (campaignId: string) => void;
  showRemoveButton?: boolean;
};

export const CampaignList: React.FC<CampaignListProps> = ({
  campaigns,
  onRemove,
  showRemoveButton = false,
}) => {
  return (
    <VStack align="stretch" spacing={2}>
      {campaigns.map((campaign) => (
        <Box
          key={campaign.id}
          px={3}
          py={2}
          borderRadius="md"
          border="1px solid"
          borderColor="surface.border"
          _hover={{ bg: 'sidebar.itemHoverBg' }}>
          <HStack justify="space-between" align="center">
            <HStack spacing={3}>
              <Icon iconName="speaker" boxSize={5} color="content.muted" />
              <Text
                fontSize="md"
                color="content.title"
                fontFamily="marketingPage">
                {campaign.name}
              </Text>
            </HStack>
            {showRemoveButton && onRemove && (
              <IconButton
                aria-label="Remove campaign"
                icon={<Icon iconName="close" boxSize={3} />}
                size="sm"
                variant="ghost"
                colorScheme="red"
                onClick={() => onRemove(campaign.id)}
                _hover={{ bg: 'surface.errorHover' }}
              />
            )}
          </HStack>
        </Box>
      ))}
    </VStack>
  );
};
